import {
    Box,
    ListItem,
    Tag,
    Text
} from '@chakra-ui/react';

export function SongDataItem ({headerText, valueText, addShift}) {
    return(
            <Box marginLeft="15px" marginBottom={1}>
                <Tag display="inline-grid" textAlign="right" paddingRight="5px" marginRight={1} width="85px">
                    {headerText}:
                </Tag> 
                <Text marginTop={1} marginBottom={1} position="relative" top={addShift ? "4px" : "0px"} display="inline">
                    {valueText}
                </Text>
            </Box>
    );
}